import api from '@/client/core/api'
import { IndustryListResponse } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * GET /twitter_benchmark_campaign_posts/industry
 */
export async function getTwBenchmarkIndustries(groupId: number): Promise<TwBenchmarkApiResult<IndustryListResponse>> {
  const response = await api.get<TwBenchmarkApiResponse<IndustryListResponse>>(
    '/twitter_benchmark_campaign_posts/industry',
    { params: { groupId } }
  )

  return handleApiResponse<IndustryListResponse>(response)
}
